'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  UNPUBLISHED: 'Unpublished',
  PUBLISHED_INVESTOR_PORTAL: 'Published (Investor Portal)',
  PUBLISHED_MARKETING_AND_INVESTOR: 'Published (Marketing Site & Investor Portal)'
});